
import React from 'react';
import { Loader2, CheckCircle2 } from 'lucide-react';

export interface CrawlStage {
  title: string;
  icon: React.ReactNode;
  isActive: boolean;
  isCompleted: boolean;
}

interface CrawlStagesListProps {
  stages: CrawlStage[];
  progress: number;
}

const CrawlStagesList: React.FC<CrawlStagesListProps> = ({ stages, progress }) => {
  return (
    <div className="space-y-4">
      {stages.map((crawlStage, index) => (
        <div 
          key={index} 
          className={`flex items-center space-x-3 ${
            crawlStage.isActive 
              ? 'text-primary' 
              : crawlStage.isCompleted 
                ? 'text-green-500' 
                : 'text-muted-foreground'
          }`}
        >
          <div className="flex-shrink-0 h-8 w-8 rounded-full bg-purple-600/50 flex items-center justify-center">
            {crawlStage.isCompleted ? (
              <CheckCircle2 size={18} className="text-green-400" />
            ) : crawlStage.isActive ? (
              <Loader2 size={18} className="animate-spin" />
            ) : (
              React.cloneElement(crawlStage.icon as React.ReactElement, { size: 18, className: "text-muted-foreground" })
            )}
          </div>
          <span className={`text-sm ${
            crawlStage.isActive ? 'font-medium' : ''
          }`}>
            {crawlStage.title}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CrawlStagesList;
